import * as S from "./EventCardSkeleton.style";

const EventCardSkeleton = () => {
  return (
    <S.EventCard>
      <S.FlexBox>
        <S.LongContent />
        <S.ShortContent />
        <S.ShortContent />
      </S.FlexBox>
      <S.ImageSkeleton />
    </S.EventCard>
  );
};

export default EventCardSkeleton;
